import React from 'react';
import classNames from 'classnames';
import styles from './ToggleGroup.module.scss';

export interface ToggleOption<T extends string = string> {
	key: T;
	label: string;
	icon?: React.ReactNode;
}

interface ToggleGroupProps<T extends string = string> {
	options: ToggleOption<T>[];
	value: T;
	onChange: (value: T) => void;
	className?: string;
	borders?: 'rounded' | 'circle';
}

function ToggleGroup<T extends string = string>({
	options,
	value,
	onChange,
	className,
	borders = 'circle'
}: ToggleGroupProps<T>): React.ReactElement {
	return (
		<div
			className={classNames(
				styles.container,
				{
					[styles['container--rounded']]: borders === 'rounded'
				},
				className
			)}
		>
			{options.map((option) => (
				<button
					key={option.key}
					type="button"
					aria-pressed={value === option.key}
					className={classNames(styles.option, {
						[styles['option--active']]: value === option.key,
						[styles['option--rounded']]: borders === 'rounded'
					})}
					onClick={() => onChange(option.key)}
				>
					{option.icon && (
						<span
							className={classNames(styles.option__icon, {
								[styles['option__icon--rounded']]:
									borders === 'rounded'
							})}
						>
							{option.icon}
						</span>
					)}
					{option.label}
				</button>
			))}
		</div>
	);
}

export default ToggleGroup;
